import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_CAPABILITIES,
  GPX_ROUTES,
} from '@rsos/gainsight';

const LEGACY_CATEGORY = 'CallTakerMode';

const CTM_EVENT_NAMES = {
  ENABLED: 'tools_ctm_enabled',
  ICON_CLICKED: 'tools_ctm_icon_clicked',
  ACCEPTED_CALL: 'tools_ctm_accepted_call',
};

// when user turns on/off
export const trackCTMEnabled = (isEnabled, positionID, irpVersion) => {
  gspx.trackEvent({
    name: CTM_EVENT_NAMES.ENABLED,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.TOOLS,
    additionalKeys: {
      legacy_category: LEGACY_CATEGORY,
      legacy_name: `${isEnabled ? 'Enabled' : 'Disabled'} Call Taker Mode`,
      Category: 'Call Taker Mode',
      'Launched date': new Date(),
      irpVersion,
      positionID,
    },
  });
};

// when Call Taker Mode Icon is clicked
// clicking the icon does not automatically enables CTM,
// it opens up positionSelectionModal if its already disabled
export const trackCTMIconClicked = (positionID, irpVersion) => {
  gspx.trackEvent({
    name: CTM_EVENT_NAMES.ICON_CLICKED,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.TOOLS,
    additionalKeys: {
      legacy_category: LEGACY_CATEGORY,
      legacy_name: 'Call Taker Mode Icon clicked',
      Category: 'Call Taker Mode',
      'Launched date': new Date(),
      irpVersion,
      positionID,
    },
  });
};

// when a call comes in and Call Taker Mode auto opens it
export const trackCTMAcceptedCall = (
  positionID,
  irpVersion,
  payloadID,
  requestID,
) => {
  gspx.trackEvent({
    name: CTM_EVENT_NAMES.ACCEPTED_CALL,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.TOOLS,
    additionalKeys: {
      legacy_category: LEGACY_CATEGORY,
      legacy_name: 'Automatically opened a call via Call Taker Mode',
      Category: 'Call Taker Mode',
      'Launched date': new Date(),
      irpVersion,
      positionID,
    },
    entities: {
      payload_id: payloadID,
      request_id: requestID,
    },
  });
};
